import { CountryListDTO, MasterLookUpDTO } from '@utils/interfaces';

export enum InsuranceFormType {
  PRIMARY = 'primaryInsuranceDetails',
  SECONDARY = 'secondaryInsuranceDetails',
}

export interface IInsuranceFormProps {
  currentIndex: number;
  insuranceFormType: InsuranceFormType;
  gender: MasterLookUpDTO | undefined;
  countryStates: CountryListDTO | undefined;
  countries: CountryListDTO | undefined;
  holders: MasterLookUpDTO | undefined;
  onValidate: (val: boolean, index: number) => void;
  defaultInsuranceID: string | undefined;
  defaultInsuranceNameOther?: string;
}

export interface InsuranceDetailsInfo {
  insuranceId?: string;
  submitInsurancePlan?: string;
  provideInsuranceDetails?: string;
  other?: string;
  insuranceNameOther?: string;
  insuranceMemberId?: string;
  insuranceMemberIdOther?: string;
  isHolder?: string;
  firstName?: string;
  lastName?: string;
  gender?: string;
  dateOfBirth?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  country?: string;
  zipCode?: string;
  relationship?: string;
  sameAsForPrimaryInsurance?: boolean;
  phone?: {
    number?: string;
    prefix?: string;
  };
}
